export const ALL_LESSONS_KEY = 'Units 1-4'
export const REPORT_LINK_HREF = '/reports/k8?site='
export const UNIT_5_GRADES = ['grade-6', 'grade-7', 'grade-8']
export const UNIT_5_NAME = 'Unit 5'
